import { render } from "./ChoiceSummary.vue?vue&type=template&id=5749d40c"
import script from "./ChoiceSummary.vue?vue&type=script&lang=js"
export * from "./ChoiceSummary.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__